import React from "react";

const ReservationExternalStepBankTransfer = ({ bankTransfer }) => {
    return <>
        <div className={'text-center py-4'}>
            <i className="fas fa-check-circle text-primary fs-1 mb-3"></i>
            <h1 className={'h5 text-uppercase my-4'}>
                {window.translations.reservationExternal.finishHeading}
            </h1>
            <p>
                {window.translations.reservationExternal.finishText}
            </p>
        </div>

        <div className="row justify-content-center mb-4">
            <div className="col-md-8 border">
                <div className="p-3">
                    <div className="d-flex align-items-center justify-content-between flex-md-row flex-column">
                        <div>
                            <div className="mb-2">
                                <strong>Číslo účtu:</strong>
                                <div>{bankTransfer.accountNumber}</div>
                            </div>
                            <div className="mb-2">
                                <strong>Banka:</strong>
                                <div>{bankTransfer.bankName}</div>
                            </div>
                            <div className="mb-2">
                                <strong>Částka:</strong>
                                <div>{bankTransfer.amount} Kč</div>
                            </div>
                            <div className="mb-2">
                                <strong>Variabilní symbol:</strong>
                                <div>{bankTransfer.variableSymbol}</div>
                            </div>
                        </div>
                        <div>
                            <div dangerouslySetInnerHTML={{ __html: bankTransfer.qrCode }} />
                            <div className="text-center mt-3">QR PLATBA</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>;
};

export default ReservationExternalStepBankTransfer;
